import { render, staticRenderFns } from "./ProductQuotationListing.vue?vue&type=template&id=dda494aa"
import script from "./ProductQuotationListing.vue?vue&type=script&lang=js"
export * from "./ProductQuotationListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports